<template>
  <component :is="type" :href="href" class="button">
    <slot/>
  </component>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
  },
  computed: {
    type() {
      if (this.href) {
        return 'a';
      }
      return 'button';
    },
  },
};
</script>

<style scoped>
  .button {
    display: inline-block;
    margin: 0.5em 0;
    padding: 1em 1.5em;
    background: transparent;
    border: 2px solid #FA5E42;
    border-radius: 2em;
    /* color: #FA5E42; */
    text-align: center;
    font-size: 1em;
    font-weight: 700;
    letter-spacing: 0.02em;
    line-height: 1;
    text-decoration: none;
    text-transform: uppercase;
    cursor: pointer;
    transition: 0.2s;
  }

  .white-bg .button{
    color: #FA5E42;
  }

  .button:hover {
    background: #FA5E42;
    color: #fff;
  }

  .button.btn-small {
    padding: 5px 18px;
    text-transform: none;
    border-radius: 30px;
    border: 2px solid #FA5E42;
    line-height: inherit;
    font-weight: inherit;
  }

  .button.btn-white {
    color: #fff;
    border: 2px solid #fff;
  }

  .button.btn-white:hover {
    background-color: rgba(0,0,0,.1);
  }

</style>



// WEBPACK FOOTER //
// src/components/Btn.vue